"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5445%3A1462))
 * @lastsynced 2026-10-29T13:49:45.167Z
 * @donotoptimize - optimizing breaks path due to dangling clipPath url reference
 * @trackcomponent
 */
export const Calculation = createSVGIcon(
  <path
    d="M11.9998 0.857178V23.1429M0.856934 12H23.1426M4.2855 6.42861H8.57122M15.8569 6.42861H19.2855M15.8569 15.8572H19.2855M15.8569 19.2857H19.2855M6.42836 4.28575V8.57146M4.61112 15.7542L8.2454 19.3884M8.2454 15.7542L4.61112 19.3884M19.7141 0.857178H4.2855C2.39196 0.857178 0.856934 2.3922 0.856934 4.28575V19.7143C0.856934 21.6079 2.39196 23.1429 4.2855 23.1429H19.7141C21.6077 23.1429 23.1426 21.6079 23.1426 19.7143V4.28575C23.1426 2.3922 21.6077 0.857178 19.7141 0.857178Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "Calculation",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
